module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4zOTEiIGhlaWdodD0iMjUuODQyIiB2aWV3Qm94PSIwIDAgMjEuMzkxIDI1Ljg0MiI+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEzLjQxMSAxNy4zMDlMOS4wMDYgMTIuOTJsNC40MDUtNC4zODgtLjUxNS0uNTA5LTQuOTE3IDQuODk3IDQuOTE3IDQuODk4eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/arrow-left.svg
// module id = 91
// module chunks = 0